import { CommonData } from "../datastructures/gamestate/gameData";
import {
  setAllowedInputs,
  enableGamble,
  isObjectEmpty,
  onOptionButtonDownRedirectDepositPage,
} from "./Functions_General";
import * as jQuery from "jquery";
// import { Tournament } from "../gameLib/Tournament/Main_Tournament";
// import { Credits } from "../datastructures/Credits";

///GAME BAR FUNCTIONS =============================================
export function stopAutoPlay(activeGameData: CommonData) {
  // console.log("stopAutoPlay")
  activeGameData.autoCountListselected = 0;
  activeGameData.gameBar.setAutoPlayCount(activeGameData.autoCountListselected);
  activeGameData.autoPlayTicker.stop();
  if (activeGameData.activePlaying == false) {
    // activeGameData.setAllowedInputs(activeGameData);
    // let enableInputs = ((activeGameData.betResponse.gameContext.contextData)).allowedInputActions;
    let enableInputs =
      activeGameData.betResponse.gameContext.contextData.allowedInputActions;
    if (jQuery.inArray("BET", enableInputs) >= 0) {
      enableChangeBet(true, activeGameData);
    }
    if (jQuery.inArray("GAMBLE", enableInputs) >= 0) {
      enableGamble(true, activeGameData);
    }
  }
}
//  Bet popper and function ====================================================================================================
export function onBetChangeUpDown(param: string, activeGameData: CommonData) {
  if (activeGameData.isEmulation && activeGameData.emulationMode != undefined) {
    return;
  }

  // if(activeGameData.activePlaying==undefined){activeGameData.activePlaying=false}
  // console.log(activeGameData)
  if (activeGameData.activePlaying === false) {
    if (param === "up") {
      // console.log(param)
      if (activeGameData.betIndex < activeGameData.betList.length - 1) {
        activeGameData.betIndex += 1;
        activeGameData.betSelected =
          activeGameData.betList[activeGameData.betIndex];
        changeBid(activeGameData);
      }
    }

    if (param === "down") {
      if (activeGameData.betIndex > 0) {
        // console.log(param)
        activeGameData.betIndex -= 1;
        activeGameData.betSelected =
          activeGameData.betList[activeGameData.betIndex];
        changeBid(activeGameData);
      }
    }

    if (param != "down" && param != "up") {
      //verify if same bet was selected
      activeGameData.betIndex = parseInt(param);
      if (
        activeGameData.betSelected !=
        activeGameData.betList[activeGameData.betIndex]
      ) {
        if (
          Date.now() - activeGameData.betTimer < 700 &&
          activeGameData.isMobile &&
          activeGameData.betResponse.gameContext.contextData != undefined
        ) {
          // askConfirmation
          activeGameData.betIndex = parseInt(param);
          activeGameData.betConfirmation.setBodyText(
            activeGameData.gameTextGeneral.StakeChangeConfiramtion1 +
              activeGameData.betList[
                activeGameData.betIndex
              ].getDisplayValue() +
              ".\n" +
              activeGameData.gameTextGeneral.StakeChangeConfiramtion2
          );
          activeGameData.betConfirmation.setMessageBoxVisibile(true, -1);
          activeGameData.disableAllBtns(activeGameData);
          // activeGameData.disableAllBtns(activeGameData);
        } else {
          activeGameData.betSelected =
            activeGameData.betList[activeGameData.betIndex];
          changeBid(activeGameData);
        }
      }

      onBetChangeWindow(activeGameData);
    }

    checkUserBalToBet(activeGameData);
  }

  //---nico game autoclose the symbol paytableoverlay if open
  if (
    activeGameData.mainGame?.getClickableSymbolpaytableOverlay?.() != undefined
  ) {
    activeGameData.mainGame.getClickableSymbolpaytableOverlay().close();
  }
}
export function changeBid(activeGameData: CommonData) {
  // console.log(activeGameData.betSelected)
  activeGameData.gameBar.setBetValue(
    activeGameData.betSelected.getDisplayValue()
  );
  activeGameData.betTimer = Date.now();
  if (activeGameData.paytable) {
    activeGameData.paytable.updateAllPaytable();
  }

  //--if the context is empty add the stake to the replay
  //  console.log(activeGameData.betResponse.gameContext.contextData.stake.amount,activeGameData.betSelected.getServerVal())
  if (
    (activeGameData.betResponse.gameContext.contextData.stake.amount,
    activeGameData.betSelected.getServerVal())
  ) {
    activeGameData.betResponse.gameContext.contextData.stake.amount = activeGameData.betSelected.getServerVal();
  }

  if (activeGameData.BuyBonus != undefined) {
    activeGameData.BuyBonus.updatedisplayPriceOpenCloseBtn(
      activeGameData.betSelected.getServerVal()
    );
  }

  onBetChangeUpdateMinimumStakePopup(activeGameData);
}

export function onBetChangeUpdateMinimumStakePopup(activeGameData: CommonData) {
  //---update the minimum stake popup
  //---if the game is not in the list of games with the minimum stake popup
  const rouletteGamesId = [300001, 300002];
  if (rouletteGamesId.includes(activeGameData.gameId)) {
    //ignore the minimum stake popup logic here since the roulette games have a different logic
    return;
  }

  activeGameData.minimumStakePopup.setCurrentStake(
    activeGameData.betSelected.getValue()
  );

  //---update the stake for the minimum stake popup
  const allStakesInCent = activeGameData.loginResponse.gameSettings.stakes;
  const lowestStakeInCent = Math.min(...allStakesInCent);
  const lowestStakeInEur = lowestStakeInCent / 100;
  activeGameData.minimumStakePopup.setMinStake(lowestStakeInEur);
}

export function onBetChangeUpdateMinimumStakePopup_RouletteGames(
  activeGameData: CommonData,
  selectedBet: number
): void {
  activeGameData;

  activeGameData.minimumStakePopup.setCurrentStake(selectedBet);

  //---update the stake for the minimum stake popup
  const allStakesInCent = activeGameData.loginResponse.gameSettings.stakes;
  const lowestStakeInCent = Math.min(...allStakesInCent);
  const lowestStakeInEur = lowestStakeInCent / 100;
  activeGameData.minimumStakePopup.setMinStake(lowestStakeInEur);
}

export function onBetChangeWindow(activeGameData: CommonData) {
  activeGameData.betPopper.onClick();
}

export function balanceCheckTicker<T extends CommonData>(activeGameData: T) {
  // console.log('startTicker')
  let maxDuration = 15 * 1000 * 60;
  let updateBalFrequency = 5 * 1000; //request every 10sec for bal
  let deltaTime = Date.now();
  let startTime = Date.now();
  let tickerBal = new PIXI.ticker.Ticker();
  tickerBal.stop();
  tickerBal.add(() => {
    if (Date.now() - deltaTime > updateBalFrequency) {
      deltaTime = Date.now();
      // requestNewBalance(this.activeGameData)
      // console.log('REQUEST TICKER')
      activeGameData.requestNewBalance(activeGameData);
      // console.log('newBal',this.activeGameData.balance.value , this.activeGameData.betSelected.value,delta)
    }
    if (
      Date.now() - startTime > maxDuration ||
      activeGameData.balance.value >= activeGameData.betSelected.value
    ) {
      //Autodestroy after 15 minutes or if bal enouhg
      if (activeGameData.lowBalanceMessage.getIsOpen()) {
        // lowBalConfirm(activeGameData)
        activeGameData.lowBalanceMessage.setMessageBoxVisibile(false);
        // setAllowedInputs(activeGameData)
      }
      lowBalConfirm(activeGameData);
      activeGameData.lowBalTickerActive = false;
      tickerBal.stop();
      tickerBal.destroy();
      // checkUserBalToBet();
    }
  });
  tickerBal.start();
}

export function checkUserBalToBet<T extends CommonData>(activeGameData: T) {
  // console.log(activeGameData.betResponse)

  let gameFinished =
    activeGameData.betResponse.gameContext.contextData.finished;

  if (gameFinished && activeGameData.isTournament) {
    activeGameData.tournamentmode.requeServerForScore(); //do a call end of the round
  }

  let nonPlayableNeedRecharge =
    activeGameData.balance.value < activeGameData.betList[0].getValue();
  // let nonPlayableNeedLowStakee=(nonPlayableNeedRec?harge==false && activeGameData.betSelected.value>activeGameData.balance.value );
  if (
    nonPlayableNeedRecharge &&
    activeGameData.isTournament == true &&
    gameFinished
  ) {
    stopAutoPlay(activeGameData);

    activeGameData.tournamentmode.setEndScreen();

    //end of the tournament game
  } else if (activeGameData.balance.value < activeGameData.betSelected.value) {
    // let gameFinished=activeGameData.betResponse.gameContext.contextData.finished
    if (
      activeGameData.gameMode != "bonusGame" ||
      (activeGameData.freeSpinsCount === 0 && gameFinished == true)
    ) {
      stopAutoPlay(activeGameData);
      activeGameData.lowBalanceMessage.setHeadText(
        activeGameData.gameTextGeneral.noBalanceHead
      );
      if (activeGameData.isTournament) {
        activeGameData.lowBalanceMessage.setBodyText(
          activeGameData.tournamentText.LOWERYOURSTAKE
        );
      } else {
        activeGameData.lowBalanceMessage.setBodyText(
          activeGameData.gameTextGeneral.noBalanceBody
        );
      }

      if (
        activeGameData.lowBalanceMessage.getIsOpen() == false &&
        gameFinished
      ) {
        activeGameData.lowBalanceMessage.setMessageBoxVisibile(true, -1);
        // disableAllBtns(activeGameData)
      }

      // activeGameData.lowBalanceMessage.setMessageBoxVisibile(true);
      activeGameData.gameBar.setAutoPlayBtn(false);
    } else {
      activeGameData.gameBar.setAutoPlayBtn(true);
    }

    if (
      activeGameData.lowBalTickerActive == false &&
      activeGameData.isTournament == false
    ) {
      activeGameData.lowBalTickerActive = true;
      balanceCheckTicker(activeGameData);
      //start autoBalance check
    }
  } else {
    //clsoe if open
    if (activeGameData.lowBalanceMessage.getIsOpen()) {
      activeGameData.lowBalanceMessage.setMessageBoxVisibile(false);
      setAllowedInputs(activeGameData);
    }
  }
}

export function depositURL(activeGameData: CommonData) {
  lowBalConfirm(activeGameData);
  onOptionButtonDownRedirectDepositPage();
}
export function lowBalConfirm(activeGameData: CommonData) {
  // console.log(activeGameData.betResponse)
  // activeGameData.lowBalanceMessage.setMessageBoxVisibile(false);

  enablePlay(true, activeGameData);
  activeGameData.playable = true;
  activeGameData.activePlaying = false;
  activeGameData.resetAllBtns(activeGameData);
  setAllowedInputs(activeGameData);
  // console.log('resetsetAll')
}

export function betConfirm(bool: Boolean, activeGameData: CommonData) {
  // console.log('CONFIRMED')
  if (bool) {
    activeGameData.betSelected =
      activeGameData.betList[activeGameData.betIndex];
    changeBid(activeGameData);
  } else {
    // dont change
  }
  activeGameData.betConfirmation.setMessageBoxVisibile(false);
  activeGameData.resetAllBtns(activeGameData);
}

//Autoplay Poppers Functions==========================================================================================

export function onChangeAutoplay(param: string, activeGameData: CommonData) {
  // activeGameData.sound.play('btnClick');
  let index = parseInt(param);
  activeGameData.autoCountListselected = activeGameData.autoplayPopper.getAutoPlayCountSelected(
    index
  ); // activeGameData.autoplayPopper.autoplayCounts[parseInt(param)];
  activeGameData.gameBar.setAutoPlayCount(activeGameData.autoCountListselected);
  onAutoPlayChangeWindow(activeGameData); //close once autoplay selected
  //console.log(param)
  // activeGameData.autoplayPopper.onClick()
}
export function onAutoPlayChangeWindow(activeGameData: CommonData) {
  activeGameData.autoplayPopper.onClick();
  if (activeGameData.autoCountListselected > 0) {
    activeGameData.playFunction();
  }
}
export function setAutoPlay(activeGameData: CommonData) {
  if (activeGameData.autoCountListselected > 0) {
    stopAutoPlay(activeGameData);
  } else {
    onAutoPlayChangeWindow(activeGameData);
  }
}

export function recoverGameBar(activeGameData: CommonData) {
  // console.log(activeGameData.betResponse.gameContext)

  recoverStake(
    activeGameData.betResponse.gameContext.contextData.stake.amount,
    activeGameData
  );

  if (activeGameData.bonusGameModeStarted === false) {
    if (activeGameData.betResponse.gameContext.contextData.win != undefined) {
      if (
        isObjectEmpty(
          activeGameData.betResponse.gameContext.contextData.win
        ) === false
      ) {
        recoverWin(
          activeGameData.betResponse.gameContext.contextData.win.credits.amount,
          activeGameData
        );
      }
    }
  } else {
    if (
      activeGameData.betResponse.gameContext.contextData.bonusSpinWin !=
      undefined
    ) {
      recoverWin(
        activeGameData.betResponse.gameContext.contextData.bonusSpinWin.credits
          .amount,
        activeGameData
      );
    }
  }

  ///-- special cases for the christmasgames nad sergio game recovery

  if (
    activeGameData.gameId == 100008 ||
    activeGameData.gameId == 100010 ||
    activeGameData.gameId == 100011 ||
    activeGameData.gameId == 100014
  ) {
    // console.log("CHRISTMAS GAME RECOVERY")
    recoverChristmasGameBar(activeGameData);
  }
}

export function recoverChristmasGameBar(activeGameData: CommonData) {
  // console.log(activeGameData.betResponse.gameContext)

  recoverStake(
    activeGameData.betResponse.gameContext.contextData.stake.amount,
    activeGameData
  );

  recoverWin(
    activeGameData.betResponse.gameContext.contextData.gameRoundBalance.credits
      .amount,
    activeGameData
  );
  //
  if (
    activeGameData.betResponse.gameContext.contextData.bonusGameResult !=
    undefined
  ) {
    recoverWin(
      activeGameData.betResponse.gameContext.contextData.win.credits.amount,
      activeGameData
    );
  }
}

export function recoverStake(stake: number, activeGameData: CommonData) {
  // console.log("STAKE-RECOVERED",stake)
  let betArray = [];

  for (let index = 0; index < activeGameData.betList.length; index++) {
    betArray[index] = activeGameData.betList[index].value;
  }

  activeGameData.betIndex = betArray.indexOf(stake);
  if (activeGameData.betIndex == -1) {
    console.log("Possible Stakes: ", betArray, " Recovering Stake: ", stake);
    console.log("Mismatch stake with the setting");
  }
  activeGameData.betSelected = activeGameData.betList[activeGameData.betIndex];
  // //-do reset of stake
  changeBid(activeGameData);
  //---

  // onBetChangeWindow(activeGameData); //close the betWindow
  activeGameData.betPopper.setClosed();
  // activeGameData.betSelected.updateValue(stake);//( activeGameData.winValue=((activeGameData.betResponse.balance)).credits.amount);
  activeGameData.gameBar.setBetValue(
    activeGameData.betSelected.getDisplayValue()
  );
}
function recoverWin(win: number, activeGameData: CommonData) {
  activeGameData.winValue.updateValue(win); //( activeGameData.winValue=((activeGameData.betResponse.balance)).credits.amount);
  activeGameData.gameBar.setWinValue(activeGameData.winValue.getDisplayValue());
}

export function enableCollect(bool: boolean, activeGameData: CommonData) {
  if (bool) {
    // console.log("RECOVERED TO COLLECT")
    changePlayBtnTo(2, activeGameData);
    // activeGameData.serverAction = "COLLECT";
    activeGameData.serverAction = activeGameData.API_handler.getServerActionCollect(); // "COLLECT";
  }
}

export function enableCtBonusSpin(bool: boolean, activeGameData: CommonData) {
  if (bool) {
    changePlayBtnTo(0, activeGameData);

    // activeGameData.serverAction = "BONUSSPIN";
    activeGameData.serverAction = activeGameData.API_handler.getServerActionBonusSpin(); // "BONUSSPIN";
  }
}

export function enableWildFairiesBonusSpin(
  bool: boolean,
  activeGameData: CommonData,
  index: number
) {
  if (bool) {
    changePlayBtnTo(0, activeGameData);
    if (index == 0) {
      activeGameData.serverAction = activeGameData.API_handler.getServerActionEarthBonusSpin();
    } else if (index == 1) {
      activeGameData.serverAction = activeGameData.API_handler.getServerActionIceBonusSpin();
    } else if (index == 2) {
      activeGameData.serverAction = activeGameData.API_handler.getServerActionFireBonusSpin();
    }
  }
}

export function enableBet(bool: boolean, activeGameData: CommonData) {
  // console.log('call RESET to play',bool)
  // console.log(bool)
  if (bool) {
    changePlayBtnTo(0, activeGameData);
    activeGameData.serverAction = activeGameData.API_handler.getServerActionBet(); // "BET";
  }
  enableChangeBet(bool, activeGameData);
}

//------------Helper function
export function changePlayBtnTo<T extends CommonData>(
  index: number,
  activeGameData: T
) {
  activeGameData.gameBar.setPlayButtonIndex(index);
  // activeGameData.gameBar.playBtnMode = index;
}

export function enableChangeBet<T extends CommonData>(
  bool: boolean,
  activeGameData: T
) {
  if (activeGameData.autoPlayTicker.started == false) {
    activeGameData.gameBar.setBetButtonClickable(bool);
  }
}
export function enablePlay<T extends CommonData>(
  bool: boolean,
  activeGameData: T
) {
  //change if play can be pressed or not
  // bool=false
  activeGameData.playable = bool;
  if (bool == false) {
    enableBet(false, activeGameData);
  }
}

export function gambleClick(activeGameData: CommonData) {
  //when gamble buttn is clicked display gamble game
  activeGameData.gambleGame.startGamble(true);

  activeGameData.mainGame.setWinlineHidden(); //winlines.hide();

  // enableGamble(false);
  // console.log('SET BTN VISIBLE ', false)
  displayGambleBtn(false, activeGameData);

  //reset
  stopAutoPlay(activeGameData);
}

export function displayGambleBtn(bool: boolean, activeGameData: CommonData) {
  // hideordisplayGambleBtn
  activeGameData.gameBar.setGambleButtonActive(bool); // close gamble is
  // console.log('GAMBLE BTN VISIBLE ', bool)
}

export function enablePlayIfJackpotNotAvailable(activeGameData: CommonData) {
  if (activeGameData.betResponse.jackpotContext == undefined) {
    enablePlay(true, activeGameData);
  }
}
